module.exports = __webpack_public_path__ + "static/media/psyhealth.55d92c7e.png";